import { roundToNearestMinutes } from 'date-fns/roundToNearestMinutes'
import { Trash2 } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { TimePicker } from '@/components/ui/time-picker'

interface Props {
  onChange: (date: Date | null) => void
  value?: Date
}

const Deadline = ({ value, onChange }: Props) => {
  return (
    <div className="flex">
      <div className="flex flex-1">
        <TimePicker
          value={value}
          stepHour={1}
          stepMinute={15}
          onSelect={(e) => e.value && onChange(roundToNearestMinutes(e.value, { nearestTo: 15 }))}
          className="rounded-r-none"
        />
        <Button className="rounded-l-none" variant="destructive" onClick={() => onChange(null)}>
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}

export default Deadline
